import React from 'react'

import Carousel from './carousel'

var TEXTS = [
  { de: 'Erinnerte Zukunft' },
  { sw: 'Återkallad framtid' },
  { ar: 'الذاكرة‭  ‬في‭ ‬المستقبل' },
  { en: 'recalled future' },
  { fr: 'La mémoire dans l’avenir' }
]

var INTERVAL = 3000

export default function Intro() {
  return (
    <section id="intro">
      <Carousel slides={TEXTS} interval={INTERVAL} className="intro" slideRTL />
    </section>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/intro.js
 **/